<!--
 * @Descripttion: 常量转换控件
 * @Author: zenghua.wang
 * @Date: 2021-11-01 09:27:25
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-02 11:05:30
-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    append-to-body
    center
    width="50%"
  >
    <el-form
      ref="constForm"
      size="small"
      label-width="130px"
      label-position="left"
      label-suffix=":"
      :model="data.apisConstantCvsCtls"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="名称"
            prop="ctlsName"
          >
            <el-input
              placeholder="请输入"
              clearable
              style="width: 100%"
              v-model="data.apisConstantCvsCtls.ctlsName"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="主变量"
            prop="variableSource"
          >
            <el-select
              v-model="data.apisConstantCvsCtls.variableSource"
              size="small"
              style="width:100%"
              clearable
              filterable
              placeholder="请选择"
              @change="changeFileds"
            >
              <el-option
                v-for="item in cellList"
                :key="item.title"
                :label="`${item.title} (${item.name})`"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="变量名路径"
            prop="variablePath"
          >
            <el-select
              v-model="data.apisConstantCvsCtls.variablePath"
              size="small"
              style="width:100%"
              clearable
              filterable
              allow-create
              placeholder="请选择"
            >
              <el-option
                v-for="item in fieldList"
                :key="item.field"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="新变量名"
            prop="variableNew"
          >
            <el-input
              placeholder="请输入"
              clearable
              style="width: 100%"
              v-model="data.apisConstantCvsCtls.variableNew"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="常量目录"
            prop="constCata"
          >
            <!-- <el-input
              placeholder="请输入常量目录名"
              clearable
              style="width: 100%"
              v-model="data.apisConstantCvsCtls.constCata"
            ></el-input> -->
            <el-select
              clearable
              v-model="data.apisConstantCvsCtls.constCata"
              value-key
              filterable
              placeholder="请选择常量目录名"
            >
              <el-option
                v-for="item in cataNameList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-col :span="24">
            <div
                class="const-tips"
                style="color: #3b9cd9;"
                >
                <span>注意：选择常量目录后，下方键值配置自动失效!</span>
              </div>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="const-panel">
      <h5 class="const-panel-title">键值配置</h5>
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="small"
        style="margin-bottom: 20px"
        @click="addConst"
      >新增</el-button>
      <el-table
        size="small"
        tooltip-effect="dark"
        style="width: 100%"
        border
        fit
        :data="data.apisConstantCvsCtlsDataList"
      >
        <el-table-column
          label="键"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              clearable
              placeholder="请输入"
              v-model="scope.row.dkey"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="值"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              clearable
              placeholder="请输入"
              v-model="scope.row.dvalue"
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="deleteConst(scope.$index)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <span slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="onSubmit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { createId, isEmpty } from '@/apisManage/utils'
export default {
  name: 'ApisConst',
  components: {},
  inject: ['main'],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '常量转换'
    },
    tenantId: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    change: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      visible: this.show,
      cellList: [],
      fieldList: [],
      cataNameList: [],
      rules: {
        ctlsName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        variableSource: [
          { required: true, message: '请输入变量名', trigger: 'blur' }
        ],
        variablePath: [
          { required: true, message: '请输入变量名路径', trigger: 'blur' }
        ],
        variableNew: [
          { required: true, message: '请输入新变量名', trigger: 'blur' }
        ]
        ,
        constCata: [
          { required: false, message: '常量目录code', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {},
  watch: {
    show(val) {
      if (val) {
        // 变量
        let cells = this.main.editor.parseXml2Json('vertex')
        this.cellList = cells.filter((item) => {
          return (item.value === 'table' || item.value === 'http') && item.name
        })
        this.cellList.push({title:'全局请求参数',name:'req'})
        this.changeFileds(this.data.apisConstantCvsCtls.variableSource)
        // 赋值
        this.data.apisConstantCvsCtls.id = this.main.selectCell.id
      }
      this.visible = val
    },
    visible: {
      handler(val) {
        this.$emit('update:show', val)
      },
      deep: true
    }
  },
  mounted() {
    // 获取常量下拉
    this.getcataNameData()
  },
  methods: {
    // 获取常量下拉
    getcataNameData() {
      this.$http.get('/pub/dm-const-cata/listSelect', {}
      ).then(
        response => {
          this.cataNameList = response.data
        }
      ).catch(
        error => {
          this.$message.error(error.msg)
        }
      )
    },
    changeFileds(val) {
      let cell = this.cellList.filter((item) => {
        return item.name === val
      })
      if (!isEmpty(cell)) {
        this.fieldList = []
        if (cell[0].value === 'table') {
          let list = JSON.parse(cell[0].data).apisTbCtlsReturnList || []
          list.map((el) => {
            this.fieldList.push({
              label: el.otherName || el.field,
              value: el.otherName || el.field
            })
          })
        } else if (cell[0].value === 'http') {
          let list = JSON.parse(cell[0].data).apisHttpCtlsReqParamList || []
          list.map((el) => {
            this.fieldList.push({
              label: el.param,
              value: el.param
            })
          })
        }
        // console.log(274, val, this.fieldList)
      }
    },
    addConst() {
      this.data.apisConstantCvsCtlsDataList =
        this.data.apisConstantCvsCtlsDataList.filter((item) => {
          return item.dkey || item.dvalue
        })
      this.data.apisConstantCvsCtlsDataList.push({
        id: createId(),
        constantCvsCtlsId:
          this.data.apisConstantCvsCtls.id || createId('constant'),
        tenantId: this.tenantId,
        dkey: null,
        dvalue: null
      })
    },
    deleteConst(index) {
      this.data.apisConstantCvsCtlsDataList.splice(index, 1)
    },
    onSubmit() {
      this.$refs.constForm.validate((bool) => {
        if (bool) {
          this.data.apisConstantCvsCtls.createTime =
            this.main.selectCell.createTime
          if (!isEmpty(this.data.apisConstantCvsCtlsDataList)) {
            let bool2 = this.data.apisConstantCvsCtlsDataList.every((item) => {
              return item.dkey && item.dvalue
            })
            if (!bool2) {
              this.$message.error('每行的键、值为必填字段！')
              return
            }
          }
          this.$emit('change', 'constant', this.data)
          this.visible = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.const {
  &-panel {
    padding: 15px 0;

    &-title {
      text-align: center;
      font-size: 16px;
      color: #3b9cd9;
    }
  }
}
</style>
